/**
 Запросы на сервис лояльности
 */
import { processAxiosInstance } from '@/plugins/axios';
import { apiRetry } from '@/shared/lib';

import type {
  Context,
  Plugin,
} from '@nuxt/types';
import type { NuxtAxiosInstance } from '@nuxtjs/axios';

let loyaltyApiInstance: NuxtAxiosInstance | undefined;

const loyaltyApiPlugin: Plugin = (ctx: Context) => {
  const {
    $axios,
    $config,
    req,
  } = ctx;

  let API_URL;

  if ($config.ENVIRONMENT === 'local') {
    API_URL = process.client ? location.origin : `https://${ $config.SERVICES_SITE_HOST }`;
  } else {
    API_URL = `https://${ $config.SERVICES_SITE_HOST }`;
  }

  const API_PATH = `/loyalty/api`;
  API_URL += API_PATH;

  loyaltyApiInstance = $axios.create({
    baseURL: API_URL,
    timeout: 45 * 1000,
    withCredentials: false,
  });

  processAxiosInstance(loyaltyApiInstance, req);
  apiRetry(loyaltyApiInstance, { retryCount: 5 });
};

export default loyaltyApiPlugin;

export const useLoyaltyApi = (): NuxtAxiosInstance => {
  if (loyaltyApiInstance == null) {
    throw new Error('Loyalty API instance is not defined');
  }

  return loyaltyApiInstance;
};
